import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CashTrackingRemoveCashPage } from 'src/app/modals/cash-tracking-remove-cash/cash-tracking-remove-cash.page';

const routes: Routes = [
  {
    path: '',
    component: CashTrackingRemoveCashPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CashTrackingRemoveCashPage]
})
export class CashTrackingRemoveCashPageModule {}
